import React, { Component } from 'react';
import Fuse from 'fuse.js';
import { getClinics } from '../../api/clinics';
import Map from './Map';
import Filters from '../Filters';
import Loader from './Loader';
import Error from './Error';
import './styles.css'

export default class MainMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clinics: [],
      isLoading: true,
      showError: false,
      filter: {
        option: 'fullName',
        value: '',
      },
    }
  }

  componentDidMount() {
    getClinics.then(({ data }) =>
      this.setState({ clinics: data, isLoading: false })
    ).catch(() =>
      this.setState({ showError: true, isLoading: false })
    );
  }

  handleFilterChange = event => {
    const { target: { name, value } } = event;

    if (name === 'option') {
      this.setState({ filter: { option: value, value: '' } });
    } else {
      this.setState(prevState => ({
        filter: { ...prevState.filter, [name]: value }
      }));
    }
  };

  filteredClinics = () => {
    const { clinics, filter } = this.state;

    if (filter.value === '') {
      return clinics;
    }

    const options = {
      keys: [filter.option], tokenize: true, threshold: 0, location: 0, distance: 0 };
    const fuse = new Fuse(clinics, options)

    return fuse.search(filter.value);
  }

  render() {
    const { isLoading, showError, filter } = this.state;

    if (showError) {
      return <Error />
    }

    if (isLoading) {
      return <Loader />
    }

    return [
      <Filters
        key="filters"
        option={filter.option}
        value={filter.value}
        onOptionChange={this.handleFilterChange}
        onValueChange={this.handleFilterChange}
      />,
      <Map
        key="map"
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}&v=3.exp&libraries=geometry,drawing,places`}
        loadingElement={<div />}
        containerElement={<div style={{ height: '400px' }} />}
        mapElement={<div style={{ height: `100%` }} />}
        clinics={this.filteredClinics()}
      />
    ];
  }
}
